import { Organization } from "../../../core/api/contracts/Organization";
import { authenticationResultToObject, AzureAuthenticationObject } from "./AzureAuthenticationObject";
import { RequestError } from "../../../core/api/RequestError";
import { useCallback, useContext } from "react";
import { GlobalContext } from "../../../GlobalContext";
import { AuthenticationResult } from "@azure/msal-browser";
import { LoginReply } from "../../../core/api/contracts/login";

/**
 * Attempt to authenticate and get the user's organization using azure authentication
 * @param {(org: Organization) => void} onExistingOrg
 * @param {(authObject: AzureAuthenticationObject, error: RequestError) => void} onNonExistingOrg
 * @returns {(authenticationResult: AuthenticationResult) => Promise<void>}
 */
function useAzureAuthenticate(
  onExistingOrg: (replay: LoginReply, authObject: AuthenticationResult) => void,
  onNonExistingOrg?: (authObject: AzureAuthenticationObject, error: RequestError) => void
) {
  const { auth } = useContext(GlobalContext);
  return useCallback(
    (authenticationResult: AuthenticationResult) => {
      const payload = authenticationResultToObject(authenticationResult);
      return auth
        .authMethodLogin(payload, "azure", onNonExistingOrg && ((err: RequestError) => onNonExistingOrg(payload, err)))
        .then((replay) => {
          onExistingOrg(replay, authenticationResult);
        });
    },
    [onExistingOrg, onNonExistingOrg, auth]
  );
}

export default useAzureAuthenticate;
